export default __webpack_public_path__ + "static/media/tour-4.76ae07dc.png";